export default __webpack_public_path__ + "static/media/General's Legguards of Heaven's Pass.00da072e.jpg";